import { Directive, HostListener, ElementRef } from '@angular/core';
import { ToLocalePipe } from '../pipes/to-locale.pipe';

@Directive({
  selector: '[toLocaleFormatter]',
})
export class ToLocaleFormatterDirective {
  private readonly el: HTMLInputElement;
  private readonly timeout: number;
  public delayTimer: number;

  constructor(private elementRef: ElementRef, private toLocalePipe: ToLocalePipe) {
    this.el = this.elementRef.nativeElement;
    this.delayTimer = null;
    this.timeout = 800;
  }

  ngOnInit() {
    setTimeout(() => {
      this.el.value = this.toLocalePipe.transform(this.el);
    }, this.timeout);
  }

  @HostListener('blur', ['$event.target'])
  onBlur(el) {
    this.el.value = this.toLocalePipe.transform(el);
  }

  @HostListener('keyup', ['$event.target'])
  onKeyUp(el) {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
    }
    this.delayTimer = setTimeout(() => {
      this.el.value = this.toLocalePipe.transform(el);
    }, this.timeout);
  }
}
